import React from 'react';
import { useS4AMastheadContext } from '../S4AMastheadProvider';
import { login, logout } from '../../utils/auth';
import { ButtonPrimary, ButtonSecondary, } from '@spotify-internal/encore-web/core';
export var AuthButton = function (_a) {
    var onClick = _a.onClick, userState = _a.userState, size = _a.size, fullWidth = _a.fullWidth, trackingCategory = _a.trackingCategory, className = _a.className;
    var _b = useS4AMastheadContext(), mastheadData = _b.mastheadData, InteractiveElement = _b.InteractiveElement;
    var headerEntry = mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.header;
    var useLogin = userState === 'loggedOut';
    var label = useLogin
        ? headerEntry.fields.loginButtonText
        : headerEntry.fields.logoutButtonText;
    var _c = useS4AMastheadContext(), clientId = _c.clientId, getLoginRedirectUri = _c.getLoginRedirectUri;
    return (React.createElement(InteractiveElement, { customComponent: ButtonSecondary, className: className, size: size, "data-testid": useLogin ? 'root-login' : 'root-logout', onClick: function () {
            onClick === null || onClick === void 0 ? void 0 : onClick();
            if (useLogin) {
                login(clientId, getLoginRedirectUri());
            }
            else {
                logout(clientId);
            }
        }, fullWidth: fullWidth, trackingLabel: useLogin ? 'Log In' : 'Log Out', trackingCategory: trackingCategory, target: "_self" }, label));
};
export var ClaimButton = function (_a) {
    var onClick = _a.onClick, userState = _a.userState, size = _a.size, fullWidth = _a.fullWidth, trackingCategory = _a.trackingCategory, className = _a.className, colorSet = _a.colorSet;
    var InteractiveElement = useS4AMastheadContext().InteractiveElement;
    var useDashboard = userState === 'claimed';
    var mastheadData = useS4AMastheadContext().mastheadData;
    var headerEntry = mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.header;
    var label = useDashboard
        ? headerEntry.fields.dashboardText
        : headerEntry.fields.getAccessText;
    return (React.createElement(InteractiveElement, { customComponent: ButtonPrimary, className: className, size: size, "data-testid": useDashboard ? 'navigation-dashboard' : 'navigation-claim', href: useDashboard
            ? 'https://artists.spotify.com/c'
            : 'https://artists.spotify.com/claim', onClick: onClick, trackingCategory: trackingCategory, trackingLabel: useDashboard ? 'dashboard' : "Get Access (".concat(userState, ")"), fullWidth: fullWidth, colorSet: colorSet ? undefined : 'base', UNSAFE_colorSet: colorSet }, label));
};
